import { action } from 'satcheljs';

export interface UPDATE_TABLE_CURRENT_LOADED_INDEXActionMessage {
    tableViewId: string;
    currentLoadedIndexToSet: number;
}
const defaultExport: (
    tableViewId: string,
    currentLoadedIndexToSet: number
) => UPDATE_TABLE_CURRENT_LOADED_INDEXActionMessage = action(
    'UPDATE_TABLE_CURRENT_LOADED_INDEX',
    (
        tableViewId: string,
        currentLoadedIndexToSet: number
    ): UPDATE_TABLE_CURRENT_LOADED_INDEXActionMessage => ({
        tableViewId,
        currentLoadedIndexToSet,
    })
);
export default defaultExport;
